import { render, staticRenderFns } from "./LocationImport.vue?vue&type=template&id=4bce8ed9&scoped=true&"
import script from "./LocationImport.vue?vue&type=script&lang=js&"
export * from "./LocationImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce8ed9",
  null
  
)

export default component.exports